import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

interface Group {
  buddyCount: number;
  groupNm: string;
  groupSeqNo: number;
  usrKey: string;
}

interface MobileGroupSelectProps {
  groupList: Group[];
  onChange: (value: number, option: Group) => void;
}

const MobileGroupSelect: React.FC<MobileGroupSelectProps> = ({ groupList = [], onChange }) => {
  return (
    <Select
      style={{ width: 200 }}
      placeholder="그룹 선택"
      onChange={(value, option) => onChange(value as number, option as Group)}
    >
      {groupList.length > 0 &&
        groupList.map((group) => (
          <Option key={group.groupSeqNo} value={group.groupSeqNo}>
            {group.groupNm} ({group.buddyCount})
          </Option>
        ))}
    </Select>
  );
};

export default MobileGroupSelect;
